import { useState } from "react"
import Textarea from "@/v2-ui/textarea"
import Button, {
  INPUT_ALIGNED_BUTTON_CLASSES,
} from "@/v2-backoffice-client/components/button"

export type LayerAiComposerProps = {
  isSending: boolean
  /** Switches the placeholder to the "ask for changes" wording. */
  hasSuggestions: boolean
  onSend(text: string): void
}

/**
 * The assistant's message input. Owns the draft text; Enter (without Shift)
 * or the Send button submits it.
 */
function LayerAiComposer(props: LayerAiComposerProps) {
  const { isSending, hasSuggestions, onSend } = props

  const [input, setInput] = useState("")

  function submit() {
    const text = input.trim()
    if (!text) return
    setInput("")
    onSend(text)
  }

  return (
    // items-end: the pinned-height button hugs the field's bottom edge as
    // the textarea grows with multi-line input.
    <div className="flex shrink-0 items-end gap-2">
      <Textarea
        className="min-h-9 flex-1 text-xs"
        rows={1}
        placeholder={
          hasSuggestions
            ? "Ask for changes to the suggestions…"
            : "Tell the assistant what you want…"
        }
        value={input}
        disabled={isSending}
        onChange={(event) => setInput(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault()
            submit()
          }
        }}
      />
      <Button
        size="sm"
        className={INPUT_ALIGNED_BUTTON_CLASSES}
        isLoading={isSending}
        disabled={isSending || !input.trim()}
        data-feature-code="UI_BackofficeLayers_AiAssistant_Send"
        onClick={submit}
      >
        Send
      </Button>
    </div>
  )
}

export default LayerAiComposer
